import { useEffect } from 'react';

/**
 * Хук для изменения заголовка страницы
 * @param {string} title - Заголовок страницы
 */
function useTitle(title) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title ? `${title} | ООО «Перформанс»` : 'ООО «Перформанс»';

    // Восстанавливаем предыдущий заголовок при размонтировании компонента
    return () => {
      document.title = prevTitle;
    };
  }, [title]);
}

export default useTitle;